import { useCallback } from 'react';
import { useWeb3React } from '@web3-react/core';
import useWeb3 from '../useWeb3';
import { rockBalance } from '../../utils/contractHelpers';
import { gemsRouterContract, rockRelayerContract } from '../../utils/Enviroment';

export const useRockApprove = () => {
    const { account } = useWeb3React();
    const web3 = useWeb3();
    let bigNumberApproval = "10000000000000000000000000";
    const rockApprove = useCallback(async (contractAddress, isTokenGraduated = false) => {
        if (!account) {
            console.error("No account found. Please connect your wallet.");
            return;
        }

        if (!bigNumberApproval) {
            console.error("Invalid approval amount.");
            return;
        }

        const contract = await rockBalance(contractAddress, web3);
        if (!contract) {
            console.error("Contract not initialized properly.");
            return;
        }

        const feeAmount = web3.utils.toWei(bigNumberApproval.toString(), 'ether'); // Ensure bigNumberApproval is a string or number
        let gasPrice = await web3.eth.getGasPrice();
        gasPrice = parseInt(gasPrice); // Add 1 Gwei to the gas price

        try {
            const gas = await contract.methods.approve(isTokenGraduated ? rockRelayerContract : gemsRouterContract, feeAmount).estimateGas({ from: account });
            const transaction = await contract.methods.approve(isTokenGraduated ? rockRelayerContract : gemsRouterContract, feeAmount).send({ from: account, gas, gasPrice });
            return transaction;
        } catch (error) {
            console.error("Approval error:", error.message || error);
            throw error;
        }
    }, [account, web3]);

    return rockApprove;
};